<template>
  <main data-page="admin" class="page-admin" :style="wrapperStyle" ref="wrapper">
    <div class="nav-bar flex-row">
      <div class="nav-wrap flex-row">
        <a :href="homeURL" target="_blank" class="nav-link">
          <i class="iconfont icon-home-6-line"></i>
        </a>
        <p class="data">Views: <span class="views-num">{{viewNum}}</span>&nbsp; Clicks: <span class="clicks-num">{{clickNum}}</span></p> 
      </div>
      <div class="settings-wrap flex-row">
        <i class="iconfont icon-ChartLineUp" @click="handlePopup('tracking')"></i>
        <i class="iconfont icon-settings setting" @click="handlePopup('setting')"></i>
        <i class="iconfont icon-logout-box-r-line logout" @click="handleLogout"></i>
      </div>
    </div>
    <div class="edit-section">
      <button class="btn add-btn"
              @click="handleAddBlock"
              :class="loading?'disabled-btn':''"
              :disabled="loading">Add New Block
      </button>
      <sortable-list lock-axis="y"
                     append-to=".page-admin"
                     :use-drag-handle="true"
                     helper-class="draging"
                     @sort-start="handleSortStart"
                     @sort-end="handleSortEnd"
                     @input="handleSortComplete"
                     v-model="dashboard.blocks">
        <block v-for="(item, key) in sortedBlocks"
               :index="key"
               :key="item.block_id"
               @open="handleImgPopup"
               @change="handleBlockChange"
               @removed="handleBlockRemoved"
               :item="item"/>
      </sortable-list>
      <button class="btn preview-btn" @click="handlePopup('preview')">Preview</button>
    </div>

    <tracking-popup
        v-if="showTrackingPopup"
        :options="trackingOptions"
        @update="handleSettingsChange"
        @close="handleClose">
    </tracking-popup>
    <settings-popup
        v-if="showSettingPopup"
        :options="colorOptions"
        @vcf="handleVCFHandle"
        @update="handleSettingsChange"
        @close="handleClose">
    </settings-popup>
    <preview-popup
        v-if="showPreviewPopup"
        @close="handleClose"
        :dashboard="dashboard">
    </preview-popup>
    <image-popup
        v-if="showImagePopup"
        @close="handleClose"
        @change="imagePopupChange"
        :block="imgPopupBlock">
    </image-popup>
  </main>
</template>

<script>
import trackingPopup from "./tracking-popup.vue";
import settingsPopup from "./settings-popup.vue";
import previewPopup from "./preview-popup.vue";
import imagePopup from "./image-popup.vue";
import editableInput from "./editableInput.vue";
import sortableList from "./sortable-list.vue";
import Block from "./block.vue";
import eventBus from "../../common/utils/eventBus";
import {APIError} from "../../common/utils/errors";
import loading from "../../common/utils/loading";
import adminService from "../service/adminService";

const POPUP_PREVIEW = 'preview';
const POPUP_SETTING = 'setting';
const POPUP_TRACKING = 'tracking';
const POPUP_IMAGE = 'image';
export default {
  name: "admin",
  components: {
    'tracking-popup': trackingPopup,
    'settings-popup': settingsPopup,
    'preview-popup': previewPopup,
    'image-popup': imagePopup,
    'editable-input': editableInput,
    'sortable-list': sortableList,
    'block': Block,
  },
  data() {
    return {
      currentPopup: null,
      dashboard: {
        options: {},
        blocks: [],
      },
      imgPopupBlock: {},
      loading: false,
      wrapperStyle: {},
      viewNum: 0,
      clickNum: 0,
    }
  },
  mounted() {
    eventBus.$on('error', this.handleAuthError);
    this.getDashboardDate();
    this.getTrackingNum();
  },
  beforeDestroy() {
    eventBus.$off('error', this.handleAuthError);
  },
  methods: {
    handleAuthError(error) {
      if (error instanceof APIError && error.getCode() === 401) {
        this.$router.replace({
          path: "/sign-in"
        });
      }
      if (error instanceof APIError && error.getCode() === 403) {
        this.$router.replace({
          path: "/activate"
        });
      }
    },
    handleClose(close) {
      this.currentPopup = null;
    },

    handlePopup(type) {
      this.currentPopup = type;
    },

    handleImgPopup(block) {
      this.imgPopupBlock = {...block};
      this.currentPopup = POPUP_IMAGE;
    },

    handleBlockChange(item) {
      const index = this.dashboard.blocks.findIndex((row) => {
        return row.block_id === item.block_id;
      })
      if (index > -1) {
        this.$set(this.dashboard.blocks, index, item);
      }
    },
    handleBlockRemoved(item) {
      const index = this.dashboard.blocks.findIndex((row) => {
        return row.block_id === item.block_id;
      })
      if (index > -1) {
        this.$delete(this.dashboard.blocks, index);
      }
    },

    getDashboardDate() {
      loading.show();
      this.loading = true;
      adminService.getDashboard()
          .then((data) => {
            this.dashboard = data;
            this.dashboard.blocks = Object.values(data.blocks);
            this.dashboard.options = data.options || {};
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            loading.hide();
            this.loading = false;
          })
    },

    handleAddBlock() {
      if(this.loading) return;
      loading.show();
      this.loading = true;
      const item = "New Block";
      adminService.editBlock(item)
          .then((res) => {
            console.log(res);
            this.getDashboardDate();
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(()=>{
            this.loading = false;
            loading.hide();
          })


    },

    /**
     * 选择的 icons ClassName
     */
    imagePopupChange(block) {
      loading.show();
      this.handleEditBlock(block)
          .then(() => {
            this.handleBlockChange(block);
          })
          .finally(() => {
            loading.hide();
          });
    },

    handleEditBlock(item) {
      return adminService.editBlock(item.text, item.type, item.url, item.state, item.image, item.icons, item.block_id, item.position)
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error)
          })
    },
    handleSortComplete(blocks) {
      const blockList = blocks || [];
      const total = blockList.length + 2;
      this.dashboard.blocks = blockList.map((row, index) => {
        return {
          ...row,
          position: (total -  index)
        };
      });
      loading.show();
      this.loading = true;
      return adminService.blocksSort(this.dashboard.blocks).finally(() => {
          loading.hide();
          this.loading = false;
      });
    },
    handleSortEnd() {
      this.wrapperStyle = {
        touchAction: 'auto',
      };
    },
    handleSortStart() {
      this.wrapperStyle = {
        touchAction: 'none',
      };
    },
    handleLogout() {
      loading.show();
      adminService.logout()
          .then((res) => {
            if (res) {
              loading.hide();
              this.$router.replace({
                path: "/sign-in"
              });
            }
          });
    },

    handleSettingsChange(options) {
      const dashboard = this.dashboard || {};
      const oriOptions = dashboard.options || {};
      this.$set(this.dashboard, "options", {
        ...oriOptions,
        ...options,
      });
    },

    handleVCFHandle() {
      this.getDashboardDate();
    },

    /**
     * 获取用户主页访问计数
     */

    getTrackingNum(){
      adminService.getTrackingFData()
        .then((res) => {
          this.viewNum = res.view;
          this.clickNum = res.click;
        })
        .catch((error) => {
          console.log(error)
        })
      }
  },
  computed: {
    showImagePopup() {
      return this.currentPopup === POPUP_IMAGE;
    },
    showTrackingPopup() {
      return this.currentPopup === POPUP_TRACKING;
    },
    showSettingPopup() {
      return this.currentPopup === POPUP_SETTING;
    },
    showPreviewPopup() {
      return this.currentPopup === POPUP_PREVIEW;
    },
    hostname() {
      return window.location.host || 'freelink.com';
    },
    scheme() {
      return window.location.protocol || 'https:';
    },
    username() {
      const dashboard = this.dashboard || {};
      const user = dashboard.user || {};
      return user.username || '';
    },
    homeURL() {
      return `${this.scheme}//${this.hostname}/${this.username}`
    },
    colorOptions() {
      const dashboard = this.dashboard || {};
      const options = dashboard.options || {};

      return Object.entries(options).reduce((last, [key, value]) => {
        if (key.includes('_color')) {
          const newKey = key.replace('_color', 'Color');
          last[newKey] = value;
        }
        return last;
      }, {});
    },
    trackingOptions() {
      const dashboard = this.dashboard || {};
      const options = dashboard.options || {};

      return Object.entries(options).reduce((last, [key, value]) => {
        if (key.includes('_id')) {
          last[key] = value;
        }
        return last;
      }, {});
    },
    sortedBlocks() {
      return this.dashboard.blocks.sort((first, second) => {
        return second.position - first.position;
      })
    },
  }
}
</script>